import OpenSourceLibraries from '../open-source-libraries/OpenSourceLibraries';

export default function OpenSourceLibrariesPage() {
  return <OpenSourceLibraries />;
}
